import React from 'react'

function About() {
    return (
        <div>
            <h1>CSS3 Patterns Gallery</h1>
        </div>
    )
}

export default About
